import {
	BaseService,
	ComboboxService,
	CommandService,
	DatabaseImageService,
	ExportService,
	GridDefinitionService,
	LanguageService,
	MenuService,
	PageTokenService,
	PeoplePickerService,
	TextBlockService,
	UserGridConfigService,
	UserService,
} from "./index";

/**
 * @hidden
 */
export class ServiceProvider {
	public Base: BaseService;
	public Combobox: ComboboxService;
	public Command: CommandService;
	public Export: ExportService;
	public GridDefinition: GridDefinitionService;
	public Language: LanguageService;
	public Menu: MenuService;
	public PageToken: PageTokenService;
	public PeoplePicker: PeoplePickerService;
	public TextBlock: TextBlockService;
	public UserGridConfig: UserGridConfigService;
	public User: UserService;
	public DatabaseImage: DatabaseImageService;

	constructor() {
		this.Base = new BaseService();
		this.Combobox = new ComboboxService();
		this.Command = new CommandService();
		this.Export = new ExportService();
		this.GridDefinition = new GridDefinitionService();
		this.Language = new LanguageService();
		this.Menu = new MenuService();
		this.PageToken = new PageTokenService();
		this.PeoplePicker = new PeoplePickerService();
		this.TextBlock = new TextBlockService();
		this.UserGridConfig = new UserGridConfigService();
		this.DatabaseImage = new DatabaseImageService();
		this.User = new UserService(this.TextBlock, this.Menu);
    }
}